import { Column, PrimaryColumn } from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsNumber, IsObject } from '../../validators';
import { BasicEntityWithoutId } from '../basic/basic.entity';

import { EAcquirerService } from './task.enums';

export class Account extends BasicEntityWithoutId {
  @ApiProperty()
  @PrimaryColumn('int')
  @IsNumber({}, { groups: ['error'] })
  id: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  balance: number; // total balance in cents

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  balancePaid: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  balanceSubscription: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  balancePartner: number;

  @ApiProperty()
  @IsNumber({}, { groups: ['error'] })
  @Column({ type: 'int', nullable: false, default: 0 })
  balancePromo: number;

  @IsObject({ groups: ['error'] })
  @Column({ type: 'jsonb', nullable: false, default: {} })
  customerIds: Record<EAcquirerService, string>;
}
